module.exports = require("pako");